// Admin-only CRM lead-intake administration page (#1261). Assembles the
// external call-center accounts surface and the internal Manager
// intake-duty panel. Route + menu gating is admin-only (see
// `router/routes.tsx` AdminGate + `shell/menu.ts` requireAll); this page
// adds no extra gate of its own.
import { useTranslation } from 'react-i18next';
import { CallCenterAccountsPanel } from './CallCenterAccountsPanel.js';
import { ManagerDutyPanel } from './ManagerDutyPanel.js';

export function CrmIntakeAdminPage() {
  const { t } = useTranslation(['callCenterAdmin']);
  return (
    <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 32 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700 }}>{t('callCenterAdmin:pageTitle')}</h1>
      <CallCenterAccountsPanel />
      <ManagerDutyPanel />
    </div>
  );
}
